"use client";

import React from "react";
import Image from "next/image";
import { Dialog, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ComingSoonModalProps {
	open: boolean;
	onClose: () => void;
}

const ComingSoonModal: React.FC<ComingSoonModalProps> = ({ open, onClose }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="coming-soon-modal"
			maxWidth={false}
			PaperProps={{
				sx: {
					display: "flex",
					width: "466px",
					height: "335px",
					flexDirection: "column",
					alignItems: "center",
					flexShrink: 0,
					borderRadius: "16px",
					background: "#FFF",
					boxShadow: "-40px 40px 80px -8px rgba(0, 0, 0, 0.24)",
					padding: 0,
					overflow: "hidden",
				},
			}}
		>
			{/* Background Section */}
			<Box
				sx={{
					position: "relative",
					width: "466px",
					height: "191px",
					flexShrink: 0,
					backgroundImage: `url('/assets/images/modal-background.png')`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					padding: "24px",
				}}
			>
				{/* Close Button */}
				<IconButton
					onClick={onClose}
					sx={{
						position: "absolute",
						top: 16,
						right: 16,
						zIndex: 10,
						backgroundColor: "rgba(255, 255, 255, 0.2)",
						color: "white",
						width: "32px",
						height: "32px",
						"&:hover": {
							backgroundColor: "rgba(255, 255, 255, 0.3)",
						},
					}}
				>
					<CloseIcon sx={{ fontSize: "20px" }} />
				</IconButton>

				{/* Title Text in Left Middle */}
				<h1
					style={{
						color: "#FFF",
						fontSize: "26px",
						fontStyle: "normal",
						fontWeight: 600,
						lineHeight: "34px",
						margin: 0,
						zIndex: 5,
						alignSelf: "center",
					}}
				>
					Tính năng
					<br />
					sắp ra mắt
				</h1>

				{/* Clock Icon on Right Side */}
				<Image
					src="/assets/images/clock.png"
					alt="Clock"
					width={191}
					height={187}
					style={{
						width: "191px",
						height: "187px",
						flexShrink: 0,
						aspectRatio: "143/140",
						objectFit: "contain",
					}}
					className="relative top-[10px]"
				/>
			</Box>

			{/* Text Section */}
			<Box
				sx={{
					display: "flex",
					padding: "24px",
					flexDirection: "column",
					alignItems: "flex-start",
					gap: "6px",
					alignSelf: "stretch",
				}}
			>
				{/* Main Title */}
				<h2
					style={{
						alignSelf: "stretch",
						color: "#212B36",
						fontSize: "24px",
						fontStyle: "normal",
						fontWeight: 600,
						lineHeight: "34px",
						margin: 0,
					}}
				>
					Cảm ơn bạn đã quan tâm tới tính năng này
				</h2>

				{/* Subtitle */}
				<p
					style={{
						alignSelf: "stretch",
						color: "#212B36",
						fontSize: "14px",
						fontStyle: "normal",
						fontWeight: 400,
						lineHeight: "22px",
						margin: 0,
					}}
				>
					Hãy chờ đợi ngày ra mắt để cùng khám phá sản phẩm mới.
				</p>
			</Box>
		</Dialog>
	);
};

export default ComingSoonModal;
